import styled from "styled-components";
import { Announcement } from "../Announcements/_.styled";
import { primaryContentStyles, secondaryContentStyles } from "../../App.styled";

export const PrimaryContent = styled.div`
  ${primaryContentStyles()}
  order: ${(props) => props.mobileOrder};
  // 2rem represents the margin on the Primary column
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: calc(66.666% - 2rem);
  }
`;

export const SecondaryContent = styled.div`
  ${secondaryContentStyles()}
  order: ${(props) => props.mobileOrder};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 33.3%;
  }

  ${Announcement} {
    width: 100%;
  }
`;
